import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import Card from '../Card/Card';
import { fundingTypes } from '../../flows/shared/utils';
import IndirectIcon from '../../images/indirect-rollover.png';
import { hasExistingAgreements } from '../../flows/shared/testers';

const ExistingFundingCard = () => {
  const { appState, next } = useContext(FlowContext);
  const {
    store: { existingAgreements = [] }
  } = appState;

  return (
    <Card
      id="ExistingFundingCard"
      icon={IndirectIcon}
      title={<div>Existing Account</div>}
      subtitle={
        <div>
          You can fund your new trust account using money from existing T. Rowe
          Price accounts.
        </div>
      }
      buttonText="Continue"
      buttonFunction={next(fundingTypes.FROM_EXISTING_ACCOUNT)}
      buttonID="ExistingCardBtn"
      buttonDisabled={!hasExistingAgreements(existingAgreements)}
    />
  );
};

export default ExistingFundingCard;
